var map = {
	"./MERCHANT_BLUE_YONDER_RETURNS_PORTAL.json": [
		43120,
		3120
	],
	"./MERCHANT_BPOST_RETURNS_PORTAL.json": [
		93992,
		3992
	],
	"./MERCHANT_DPD_UK_RETURNS_PORTAL.json": [
		30027,
		27
	],
	"./MERCHANT_GLS_ES_RETURNS_PORTAL.json": [
		13389,
		3389
	],
	"./MERCHANT_RETURNS_PORTAL.json": [
		26698,
		6698
	],
	"./MERCHANT_SINGAPORE_POST_RETURNS_PORTAL.json": [
		44542,
		9562
	],
	"./MERCHANT_USPS_RETURNS_PORTAL.json": [
		35330,
		5330
	],
	"./MERCHANT_VANILLA_RETURNS_PORTAL_NOT_USED.json": [
		90963,
		963
	],
	"./MERCHANT_YAMATO_RETURNS_PORTAL.json": [
		29838,
		9838
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 70392;
module.exports = webpackAsyncContext;